import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Landing from "@/views/Landing.vue";
import Partnership from "@/views/Partnership.vue";
import Register from "@/views/Register.vue";
import News from "@/views/News.vue";
import NotFound from "@/views/NotFound.vue";
import NewsDetail from "@/views/NewsDetail.vue";
import SetPassword from "@/views/SetPassword.vue";
import Events from "@/views/Events.vue";
import EventDetail from "@/views/EventDetail.vue";
import TracerStudy from "@/views/TracerStudy.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    // path: "/",
    path: "/",
    name: "landing",
    component: Landing,
  },
  {
    // path: "/partnership",
    path: "/partnership",
    name: "partnership",
    component: Partnership,
  },
  {
    // path: "/register",
    path: "/register",
    name: "register",
    component: Register,
  },
  {
    // path: "/register/:code",
    path: "/register/:code",
    name: "registerWithCode",
    component: Register,
  },
  {
    // path: "/news",
    path: "/news",
    name: "news",
    component: News,
  },
  {
    // path: "/news/:id",
    path: "/news/:id",
    name: "news-detail",
    component: NewsDetail,
  },
  {
    // path: "/set-password/:code",
    path: "/set-password/:code",
    name: "set-password",
    component: SetPassword,
  },
  {
    // path: "/takeover/:code",
    path: "/takeover/:code",
    name: "takeover",
    component: SetPassword,
  },
  {
    // path: "/:actor/reset/:token",
    path: "/:actor/reset/:token",
    name: "reset-password",
    component: SetPassword,
  },
  {
    // path: "/events",
    path: "/events",
    name: "events",
    component: Events,
  },
  {
    // path: "/event/:id",
    path: "/event/:id",
    name: "event-detail",
    component: EventDetail,
  },
  {
    // path: "/tracer-study/:code",
    path: "/tracer-study/:code",
    name: "tracer-study",
    component: TracerStudy,
  },
  {
    path: "*",
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
  routes,
});

export default router;
